import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { uploadFileWithFormData } from '../../Rest_api/Network_utility';

// Async thunk for file upload
export const uploadFile = createAsyncThunk(
  'demandForecast/uploadFile',
  async ({ file, title }: { file: File; title: string }, { rejectWithValue }) => {
    try {
      const result = await uploadFileWithFormData({
        endpoint: 'demandForecast/upload_demand_forecast_file/',  // Your backend API endpoint
        file,
        title,
      });
      return result;  // Return the result on success
    } catch (error: any) {
        console.log("--error--")
        console.log(error)
      const errorMessage = error?.__all__ ? error.__all__[0] : 'An error occurred during file upload.';
      return rejectWithValue(errorMessage);
    }

  }
);

// Initial state for demand forecast file upload
interface DemandForecastState {
  loading: boolean;
  successMessage: string | null;
  errorMessage: string | null;
}

const initialState: DemandForecastState = {
  loading: false,
  successMessage: null,
  errorMessage: null,
};

// Create the demand forecast slice
const demandForecastSlice = createSlice({
  name: 'demandForecast',
  initialState,
  reducers: {
    // Optional: Add reducers for synchronous actions here if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadFile.pending, (state) => {
        state.loading = true;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(uploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = 'File uploaded successfully.';
        state.errorMessage = null;
      })
      .addCase(uploadFile.rejected, (state, action) => {
        state.loading = false;
        state.successMessage = null;
        state.errorMessage = action.payload as string;
      });
  },
});

export default demandForecastSlice.reducer;
